import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
import _imports_1 from '../assets/order.png';
const _withScopeId = n => (_pushScopeId("data-v-41b7a542"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  style: {
    "padding": "20px 10px"
  }
};
const _hoisted_2 = {
  class: "product"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "info"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "flex-c-b"
};
const _hoisted_7 = {
  key: 0,
  class: "source"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "num"
}, "×1", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title green"
}, "邮寄信息", -1));
const _hoisted_10 = {
  class: "main"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_title purple"
}, "备注信息", -1));
const _hoisted_12 = {
  class: "main"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "注:当您完成提交预约操作后，若存在疑问请拨打服务热线进行沟通，感谢您的配合!", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_15 = {
  key: 0,
  class: "zhlogo"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  class: "footerBtn flex-c-b"
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "reserve"
}, [/*#__PURE__*/_createElementVNode("img", {
  width: "80%",
  src: _imports_1
}), /*#__PURE__*/_createElementVNode("span", null, "提交成功")], -1));
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRoute } from "vue-router";
import commonMethod from '../common/common';
import areaList from '../common/area';
export default /*#__PURE__*/_defineComponent({
  __name: 'reserve_Cup',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    onMounted(() => {
      getData();
    });
    // 查询数据
    const orderDetail = ref({});
    const overlayShow = ref(false); // 是否超90天
    const isReserved = ref(false); // 是否已预约
    const resStatus = ref(''); //预约状态
    const tip = ref('');
    const getData = () => {
      proxy.$api.post(`${proxy.$url}Index/get_soi`, {
        su: route.params.su
      }).then(res => {
        if (res.status == 1) {
          orderDetail.value = res.orderDetail;
          orderDetail.value.img = orderDetail.value.s_id == 114 ? require('@/assets/3.jpg') : require('@/assets/2.jpg');
          if (orderDetail.value.s_id != 114) {
            tip.value = '分期兑换礼品';
          }
          if (orderDetail.value.is_over_days) {
            // 如果超90天，提示不可预约
            overlayShow.value = true;
            return;
          }
          if (res.reserved == 1) {
            isReserved.value = true;
            resStatus.value = '提交成功';
          }
        } else {
          if (res.reserved == 3) {
            commonMethod.dialog('权益已废', '抱歉通知您,您已申请了退积分操作,该权益已废除,如需服务请重新兑换,感谢您的配合!', 1);
          } else {
            commonMethod.dialog('预约信息加载异常', '抱歉通知您，您的订单处于取消状态或由于系统繁忙，数据加载异常,请退出重试,感谢您的配合!', 1);
          }
        }
      }).catch(err => {
        commonMethod.dialog('预约信息加载异常', '抱歉通知您由于系统繁忙您的数据加载异常,请退出重试,感谢您的配合!', 1);
      });
    };
    // 选择预约地址事件
    const areaSelected = ref('湖北省/武汉市/江岸区');
    const showArea = ref(false);
    const areaChoose = value => {
      areaSelected.value = value[0].name + '/' + value[1].name + '/' + value[2].name;
      showArea.value = false;
    };
    // 提交预约
    const address = ref('');
    const adr = ref(null);
    const name = ref('');
    const na = ref(null);
    const phone = ref('');
    const tel = ref(null);
    const toSave = () => {
      if (!areaSelected.value) {
        commonMethod.notify('warning', '请选择地址');
        return;
      }
      if (!address.value) {
        commonMethod.notify('warning', '请填写详情地址');
        adr.value.focus();
        return;
      }
      if (!name.value) {
        na.value.focus();
        commonMethod.notify('warning', '请填写联系人姓名');
        return;
      }
      if (!/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(phone.value)) {
        commonMethod.notify('warning', '手机号码错误');
        tel.value.focus();
        return;
      }
      toSubmit();
    };
    // 请求提交预约接口
    const remark = ref('');
    const toSubmit = () => {
      commonMethod.toast('loading', '正在提交...', 0);
      proxy.$api.post(`${proxy.$url}ExpApi/toSave`, {
        soi_id: orderDetail.value.soi_id,
        sa_id: 1,
        c_name: name.value,
        c_phone: phone.value,
        address: areaSelected.value + address.value,
        res_time: '2026-01-01 08:00',
        end_time: '2026-01-01 18:00',
        remark: remark.value,
        uCode: orderDetail.value.shorturl,
        lat: 0,
        lng: 0
      }).then(res => {
        commonMethod.toast('clear');
        if (res.status == 1) {
          commonMethod.notify('success', res.results);
          getData();
        } else {
          commonMethod.notify('warning', '预约失败');
        }
      }).catch(err => {
        commonMethod.toast('clear');
        commonMethod.toast('', '预约失败');
      });
    };
    // 拨打电话
    const callCS = () => {
      window.location.href = 'tel:4006631115';
    };
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_area = _resolveComponent("van-area");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock("div", null, [isReserved.value != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: "服务兑换",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: orderDetail.value.img,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(orderDetail.value.s_name), 1), _createElementVNode("div", _hoisted_6, [tip.value ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(tip.value), 1)) : _createCommentVNode("", true), _hoisted_8])])]), _createElementVNode("div", null, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_field, {
        label: "省市区",
        modelValue: areaSelected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => areaSelected.value = $event),
        placeholder: "选择省市区",
        readonly: "",
        clickable: "",
        onClick: _cache[1] || (_cache[1] = $event => showArea.value = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showArea.value,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => showArea.value = $event),
        position: "bottom",
        style: {
          height: '40%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_area, {
          "area-list": _unref(areaList),
          onConfirm: _cache[2] || (_cache[2] = $event => areaChoose($event)),
          onCancel: _cache[3] || (_cache[3] = $event => showArea.value = false)
        }, null, 8, ["area-list"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        label: "详细地址",
        modelValue: address.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => address.value = $event),
        placeholder: "填写街道、小区",
        ref_key: "adr",
        ref: adr
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "联系人",
        modelValue: name.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => name.value = $event),
        placeholder: "输入联系人姓名",
        ref_key: "na",
        ref: na
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "手机号",
        modelValue: phone.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => phone.value = $event),
        placeholder: "输入手机号码",
        maxlength: "11",
        type: "tel",
        ref_key: "tel",
        ref: tel
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", null, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_field, {
        modelValue: remark.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => remark.value = $event),
        type: "textarea",
        placeholder: "选填写订单备注",
        autosize: "",
        label: ""
      }, null, 8, ["modelValue"]), _createElementVNode("div", {
        class: "note"
      }, [_hoisted_13, _hoisted_14, _createElementVNode("span", {
        class: "serviceNo",
        onClick: callCS
      }, "服务热线：40066-31115")])])]), orderDetail.value.s_id == 114 ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        color: orderDetail.value.is_over_days ? '#ccc' : '#b50029',
        onClick: toSave
      }, {
        default: _withCtx(() => [_createTextVNode("确认提交")]),
        _: 1
      }, 8, ["color"])]), _createVNode(_component_van_overlay, {
        show: overlayShow.value,
        "custom-style": {
          background: 'rgba(255,255,255,0.3)'
        }
      }, null, 8, ["show"])])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_van_nav_bar, {
        title: "服务订单",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      }), _createElementVNode("div", null, [_hoisted_20, _createElementVNode("div", null, [_createVNode(_component_van_field, {
        label: "服务类型",
        modelValue: orderDetail.value.s_name,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => orderDetail.value.s_name = $event),
        readonly: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "收件地址",
        modelValue: orderDetail.value.c_address,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => orderDetail.value.c_address = $event),
        readonly: "",
        autosize: "",
        type: "textarea",
        rows: "1"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        label: "联系方式",
        modelValue: orderDetail.value.c_name,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => orderDetail.value.c_name = $event),
        "error-message": orderDetail.value.c_phone,
        readonly: ""
      }, null, 8, ["modelValue", "error-message"])])])]))]);
    };
  }
});